"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FORM_SUBSCRIPTION = void 0;
exports.DEFAULT_FORM_SUBSCRIPTION = {
    submitting: true,
    validating: true,
    active: true,
    dirty: true,
    dirtyFields: true,
    dirtySinceLastSubmit: true,
    error: true,
    errors: true,
    values: true,
    hasSubmitErrors: true,
    hasValidationErrors: true,
    initialValues: true,
    invalid: true,
    valid: true,
    modified: true,
    pristine: true,
};
//# sourceMappingURL=defaultFormSubscription.js.map